export const primaryMain: string = '#333D51'
export const primaryLight: string = '#5b6373'
export const primaryDark: string = '#232a38'

export const secondaryMain: string = '#F3C535'
export const secondaryDark: string = '#aa8925'
export const secondaryLight: string = '#f5d05d'

export const infoMain: string = '#fff'
export const infoDark: string = '#f0f0f0'
export const infoLight: string = '#fff'

// Section Backgrounds
export const primaryBg: string = '#333D51'
export const secondaryBg: string = '#F3C535'
export const primaryBgLight: string = '#F2F6F9'
export const secondaryBgLight: string = '#f3c53533'

export const whiteTextColor: string = '#FFFFFF'
export const textOnWhiteBgColor: string = '#4c5057'
export const blackTextColor: string = '#202225'
export const textFieldTextColor: string = '#e2e7f3'
export const lightOnDark: string = '#d1d6e2'
export const lightOnDark2: string = '#424d65'
export const lightOnDark3: string = '#485266'
export const chipColor: string = '#F7F8FB'
export const disabledTextColor: string = '#606266'
export const disabledBtnTextColor: string = '#9d9fa4'
export const inputBgColor: string = '#FFF'
export const disabledButtonBgColor: string = '#f0f0f0'

export const lightGray1: string = '#F2F6F9' //
export const lightGray2: string = '#F5F5FA'
export const lightGray3: string = '#F0F0F0'
export const lightGreen1: string = '#37CFBC' //2a9d8f
export const redMore: string = '#e76f51' //e76f51
export const lightYellow: string = 'rgba(243, 197, 53, 0.1)' //zlta
export const lightYellow2: string = 'rgba(243, 197, 53, 0.5)' //zlta
export const lightGreen2: string = 'rgba(46, 248, 190, 0.1)' // "#2EF8BE";
export const lightBlue1: string = 'rgba(66, 207, 243, 0.24)' //"#42CFF3";
export const lightYellow3: string = '#FFF2DF'

// Calendar Channel Colors
export const bookingColor: string = '#c8e4ff'
export const moowioColor: string = '#bbf0dd'
export const airbnbColor: string = '#f5d0d8'
export const expediaColor: string = '#f7f1c3'

export const lightBack1: string = '#F0F0F0'
export const lightBack2: string = '#DCD8D2'
export const lightBack3: string = '#B9C3C7'
export const lightBack4: string = '#F6FCFC'
export const lightBack5: string = '#D1D0CC' //?? #E8B7A7

export const INSTAGRAM_URL: string = 'https://www.instagram.com/'
export const LINKEDIN_URL: string = 'https://www.linkedin.com/'
export const TWITTER_URL: string = 'https://twitter.com/'
export const FACEBOOK_URL: string = 'https://www.facebook.com/'

export const META_URL: string = 'https://meta-test.moowio.com'
export const CLIENT_URL: string = 'https://client-test.moowio.com'
export const BLOG_URL: string = 'https://blog.moowio.com/'
export const SUPPORT_MOOWIO_EMAIL: string = 'support@moowio.com'

export enum PRODUCT_TYPE {
  TRIAL = 'TRIAL',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PRIME = 'PRIME',
}

export enum LANG {
  EN = 'EN',
  SK = 'SK',
  CZ = 'CZ',
  PL = 'PL',
  HU = 'HU',
  DE = 'DE',
  FR = 'FR',
  ES = 'ES',
}
